import React from 'react';
import { connect } from 'react-redux';

import * as SlideActions from "Data/slides/SlideActions";

import { default as SlidePreviewActions } from './SlideActions';

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    removeSlide: SlideActions.removeSlide,
    moveSlide: SlideActions.moveSlide,
    duplicateSlide: SlideActions.duplicateSlide,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SlidePreviewActions);
